export function goalReq(ascii) {
    var searchParams = new URLSearchParams();
    searchParams.set("goal", btoa(ascii));
    return "?" + searchParams.toString();
}